<!--
 * @FileDescription: 未出账期
 * @Author: 陈文景
 * @Date: 2022-12-29 14:31:12
 * @LastEditors: 最后更新作者
 * @LastEditTime: 最后更新时间
-->
<template>
  <div class="unpublished">
    <div class="header">
      <el-select v-model="parameter.packStatusList" multiple collapse-tags clearable size="medium" :placeholder="$t('Billing.Unpublished.ParcelStatus')" @change="getUnpublishedBillsList">
        <el-option :label="$t('Billing.Unpublished.shipped')" value="shipped" />
        <el-option :label="$t('Billing.Unpublished.completed')" value="completed" />
      </el-select>

      <div class="picker">
        <el-select v-model="parameter.dateType" size="medium" :placeholder="$t('Billing.Unpublished.Select')" @change="onSelectDateType">
          <el-option :label="$t('Billing.Unpublished.PaymentTime')" :value="1" />
          <el-option :label="$t('Billing.Unpublished.DeliveryTime')" :value="2" />
          <el-option :label="$t('Billing.Unpublished.StatementDate')" :value="3" />
        </el-select>
        <el-date-picker v-model="parameter.dateTime" align="center" size="medium" type="datetimerange" range-separator="-" :start-placeholder="$t('Billing.Unpublished.StartDate')" :end-placeholder="$t('Billing.Unpublished.EndDate')" :default-time="['00:00:00', '23:59:59']" value-format="timestamp" @change="changeDatePicker" />
      </div>

      <BatchSearch :option="searchOptins" :selected="parameter.searchType" @select="selectSearchType" @search="handleSearch" @clear="clearSearchValue" />
    </div>

    <el-table v-loading="loading" ref="table" :data="bills" row-key="id" :style="{ width: '100%' }" height="calc(100% - 98px)" @sort-change="onTableSortChange">
      <el-table-column :label="$t('Billing.Unpublished.OrderID')" show-overflow-tooltip>
        <template v-slot="{ row }">
          {{ defaultTips(row.kkOrderId) }}
        </template>
      </el-table-column>
      <el-table-column :label="$t('Billing.Unpublished.ParcelCode')" show-overflow-tooltip :width="200">
        <template v-slot="{ row }">
          {{ defaultTips(row.packId) }}
        </template>
      </el-table-column>
      <el-table-column prop="amount" :label="$t('Billing.Unpublished.Bills')" show-overflow-tooltip sortable="custom">
        <template v-slot="{ row }">
          {{ amount(row.amount) }}
        </template>
      </el-table-column>
      <el-table-column :label="$t('Billing.Unpublished.TableColumnParcelStatus')" show-overflow-tooltip>
        <template v-slot="{ row }">
          <span v-if="row.packStatus" class="pack-status">{{ packStatus(row.packStatus) }}</span>
          <span v-else>-</span>
        </template>
      </el-table-column>
      <el-table-column prop="paymentDate" :label="$t('Billing.Unpublished.TableColumnPaymentTime')" sortable="custom" show-overflow-tooltip>
        <template v-slot="{ row }">
          {{ defaultTips(formatTimeStamp(row.paymentDate)) }}
        </template>
      </el-table-column>
      <el-table-column prop="deliveryDate" :label="$t('Billing.Unpublished.TableColumnDeliveryTime')" sortable="custom" show-overflow-tooltip>
        <template v-slot="{ row }">
          {{ defaultTips(formatTimeStamp(row.deliveryDate)) }}
        </template>
      </el-table-column>
      <el-table-column prop="billingDateStr" :label="$t('Billing.Unpublished.TableColumnStatementDate')" sortable="custom" show-overflow-tooltip>
        <template v-slot="{ row }">
          {{ defaultTips(row.billingDateStr) }}
        </template>
      </el-table-column>

      <div slot="empty" class="not-data">
        <img src="~@/assets/img/undraw_random_thoughts_re_cob6.svg" alt="img.svg" />
        <div class="tips-text">{{ $t('Billing.Unpublished.NoRecord') }}</div>
      </div>
    </el-table>

    <div class="footer">
      <el-pagination :current-page.sync="parameter.pageNumber" :page-sizes="[20, 30, 40, 50]" layout="total, sizes, prev, pager, next, jumper" :total="total" @size-change="sizeChange" @current-change="currentChange" />
    </div>
  </div>
</template>

<script>
import API from '@/api'
import BatchSearch from './BatchSearch.vue'
import { formatTimeStamp } from '@/util/moment'

let parameter = {
  pageNumber: 1,
  pageSize: 20,
  packStatusList: [], // 包裹状态
  dateType: 1, // 选择的时间类型(请求前需删除该字段)
  dateTime: null, // 时间选择器双向绑定的值(请求前需删除该字段)
  paymentDateStart: undefined, // Payment Time 开始
  paymentDateEnd: undefined, // Payment TIme 截止
  deliveryDateStart: undefined, // Delivery Time 开始
  deliveryDateEnd: undefined, // Delivery Time 截止
  billingDateStart: undefined, // Statement Date 开始
  billingDateEnd: undefined, // Statement Date 截止
  searchType: 1, // 搜索类型(请求前需删除该字段)
  kkOrderIds: [], // Order ID
  packIds: [], // Parcel Code
  sortType: undefined, // 排序类型: 1.应收款 2.付款时间 3.发货时间 4.出账日期(为空则按更新时间降序)
  sort: undefined // 升降序排序: asc.升序 desc.降序
}

export default {
  components: {
    BatchSearch
  },
  data() {
    return {
      formatTimeStamp,

      parameter: { ...parameter },

      searchOptins: [
        { label: `${this.$t('Billing.Unpublished.SearchOptinsOrderID')}`, value: 1 },
        { label: `${this.$t('Billing.Unpublished.SearchOptinsParcelCode')}`, value: 2 }
      ],
      bills: [],
      total: 0,
      loading: false
    }
  },
  computed: {
    amount() {
      return (value) => {
        return value ? `+US$${value}` : '-'
      }
    },
    packStatus() {
      return (value) => {
        switch (value) {
          case 'preparing':
            return `${this.$t('Billing.Unpublished.PackStatusPreparing')}`
          case 'cancelled':
            return `${this.$t('Billing.Unpublished.PackStatusCancelled')}`
          case 'shipped':
            return `${this.$t('Billing.Unpublished.PackStatusShipped')}`
          case 'completed':
            return `${this.$t('Billing.Unpublished.PackStatusCompleted')}`
          default:
            return '-'
        }
      }
    },
    defaultTips() {
      return (value) => value || '-'
    }
  },
  created() {
    // this.getUnpublishedBillsList()
  },
  methods: {
    /**
     * API 获取未出账单列表
     *
     * @param {Boolean} reset 是否重置分页
     */
    async getUnpublishedBillsList(reset = true) {
      try {
        if (reset) {
          this.parameter.pageNumber = 1
        }
        this.loading = true
        let parameter = { ...this.parameter }
        delete parameter.dateType
        delete parameter.dateTime
        delete parameter.searchType
        let { data } = await API.getUnpublishedBillsList(parameter)
        this.bills = data.list
        this.total = data.total
        this.loading = false
      } catch (error) {
        this.loading = false
      }
    },

    /**
     * 对Table进行重新布局(解决表格抖动问题)
     */
    doLayoutTable() {
      this.$nextTick(() => {
        this.$refs.table.doLayout()
      })
    },

    /**
     * 选择日期筛选类型
     *
     * @param {Number} value 当前选中的类型
     */
    onSelectDateType(value) {
      if (this.parameter.dateTime) {
        // 付款时间
        if (value === 1) {
          if (this.parameter.deliveryDateStart && this.parameter.deliveryDateEnd) {
            this.parameter.paymentDateStart = this.parameter.deliveryDateStart
            this.parameter.paymentDateEnd = this.parameter.deliveryDateEnd
            this.parameter.deliveryDateStart = undefined
            this.parameter.deliveryDateEnd = undefined
            this.parameter.billingDateStart = undefined
            this.parameter.billingDateEnd = undefined
          }
          if (this.parameter.billingDateStart && this.parameter.billingDateEnd) {
            this.parameter.paymentDateStart = this.parameter.billingDateStart
            this.parameter.paymentDateEnd = this.parameter.billingDateEnd
            this.parameter.deliveryDateStart = undefined
            this.parameter.deliveryDateEnd = undefined
            this.parameter.billingDateStart = undefined
            this.parameter.billingDateEnd = undefined
          }
        }
        // 发货时间
        if (value === 2) {
          if (this.parameter.paymentDateStart && this.parameter.paymentDateEnd) {
            this.parameter.deliveryDateStart = this.parameter.paymentDateStart
            this.parameter.deliveryDateEnd = this.parameter.paymentDateEnd
            this.parameter.paymentDateStart = undefined
            this.parameter.paymentDateEnd = undefined
            this.parameter.billingDateStart = undefined
            this.parameter.billingDateEnd = undefined
          }
          if (this.parameter.billingDateStart && this.parameter.billingDateEnd) {
            this.parameter.deliveryDateStart = this.parameter.billingDateStart
            this.parameter.deliveryDateEnd = this.parameter.billingDateEnd
            this.parameter.paymentDateStart = undefined
            this.parameter.paymentDateEnd = undefined
            this.parameter.billingDateStart = undefined
            this.parameter.billingDateEnd = undefined
          }
        }
        // 出账日期
        if (value === 3) {
          if (this.parameter.paymentDateStart && this.parameter.paymentDateEnd) {
            this.parameter.billingDateStart = this.parameter.paymentDateStart
            this.parameter.billingDateEnd = this.parameter.paymentDateEnd
            this.parameter.paymentDateStart = undefined
            this.parameter.paymentDateEnd = undefined
            this.parameter.deliveryDateStart = undefined
            this.parameter.deliveryDateEnd = undefined
          }
          if (this.parameter.deliveryDateStart && this.parameter.deliveryDateEnd) {
            this.parameter.billingDateStart = this.parameter.deliveryDateStart
            this.parameter.billingDateEnd = this.parameter.deliveryDateEnd
            this.parameter.paymentDateStart = undefined
            this.parameter.paymentDateEnd = undefined
            this.parameter.deliveryDateStart = undefined
            this.parameter.deliveryDateEnd = undefined
          }
        }
        this.getUnpublishedBillsList()
      }
    },

    /**
     * 时间日期选择器的回调事件
     *
     * @param {Array} date 日期数组
     */
    changeDatePicker(date) {
      if (date && date.length === 2) {
        // 付款时间
        if (this.parameter.dateType === 1) {
          this.parameter.paymentDateStart = date[0]
          this.parameter.paymentDateEnd = date[1]
          this.parameter.deliveryDateStart = undefined
          this.parameter.deliveryDateEnd = undefined
          this.parameter.billingDateStart = undefined
          this.parameter.billingDateEnd = undefined
        }
        // 发货时间
        if (this.parameter.dateType === 2) {
          this.parameter.paymentDateStart = undefined
          this.parameter.paymentDateEnd = undefined
          this.parameter.deliveryDateStart = date[0]
          this.parameter.deliveryDateEnd = date[1]
          this.parameter.billingDateStart = undefined
          this.parameter.billingDateEnd = undefined
        }
        // 出账日期
        if (this.parameter.dateType === 3) {
          this.parameter.paymentDateStart = undefined
          this.parameter.paymentDateEnd = undefined
          this.parameter.deliveryDateStart = undefined
          this.parameter.deliveryDateEnd = undefined
          this.parameter.billingDateStart = date[0]
          this.parameter.billingDateEnd = date[1]
        }
      } else {
        this.parameter.paymentDateStart = undefined
        this.parameter.paymentDateEnd = undefined
        this.parameter.deliveryDateStart = undefined
        this.parameter.deliveryDateEnd = undefined
        this.parameter.billingDateStart = undefined
        this.parameter.billingDateEnd = undefined
      }
      this.getUnpublishedBillsList()
    },

    /**
     * 选择搜索类型的回调
     *
     * @param {String} value 当前选中的值
     */
    selectSearchType(value) {
      this.parameter.searchType = value
    },

    /**
     * 搜索按钮触发的回调
     *
     * @param {String} value
     */
    handleSearch(value) {
      if (value) {
        if (this.parameter.searchType === 1) {
          this.parameter.kkOrderIds = value.split(',')
          this.parameter.packIds = []
        }
        if (this.parameter.searchType === 2) {
          this.parameter.kkOrderIds = []
          this.parameter.packIds = value.split(',')
        }
      }
      this.getUnpublishedBillsList()
    },

    /**
     * 批量搜索框的清除事件的回调
     */
    clearSearchValue() {
      this.parameter.kkOrderIds = []
      this.parameter.packIds = []
      this.getUnpublishedBillsList()
    },

    /**
     * 当表格的排序条件发生变化的时候会触发该事件
     *
     * @param {Object} value 排序对象
     */
    onTableSortChange({ prop, order }) {
      if (order) {
        this.parameter.sortType = prop === 'amount' ? 1 : prop === 'paymentDate' ? 2 : prop === 'deliveryDate' ? 3 : prop === 'billingDateStr' ? 4 : undefined
        this.parameter.sort = order ? (order === 'ascending' ? 'asc' : 'desc') : undefined
      } else {
        this.parameter.sortType = undefined
        this.parameter.sort = undefined
      }
      this.getUnpublishedBillsList()
    },

    /**
     * 某行ID被点击的事件
     */
    handleBillId(id) {},

    /**
     * 每页显示数量发生改变时的回调
     *
     * @param size 每页显示数量
     */
    sizeChange(size) {
      this.parameter.pageSize = size
      this.getUnpublishedBillsList(false)
    },

    /**
     * 上一页/下一页/当前页发生改变时的回调
     *
     * @param current 当前页
     */
    currentChange(current) {
      this.parameter.pageNumber = current
      this.getUnpublishedBillsList(false)
    }
  }
}
</script>

<style lang="scss" scoped>
.unpublished {
  width: 100%;
  height: 100%;

  .header {
    margin-bottom: 15px;
    .el-select {
      /deep/.el-input__inner {
        border-radius: 2px;
      }
    }

    .picker {
      display: inline-block;
      margin: 0 12px;
      .el-select {
        width: 145px;
        /deep/.el-input__inner {
          border-right: 0;
          border-top-right-radius: 0;
          border-bottom-right-radius: 0;
          border-top-left-radius: 2px;
          border-bottom-left-radius: 2px;
        }
      }
      .el-input__inner {
        border-top-left-radius: 0;
        border-bottom-left-radius: 0;
        border-top-right-radius: 2px;
        border-bottom-right-radius: 2px;
      }
    }
  }

  .details {
    cursor: pointer;
    &:hover {
      color: #99c41c;
    }
  }

  .pack-status {
    position: relative;
    color: #99c41c;
    &::after {
      position: absolute;
      content: '';
      top: 50%;
      left: -10px;
      height: 5px;
      width: 5px;
      border-radius: 50%;
      background-color: #99c41c;
      transform: translateY(-50%);
    }
  }

  .not-data {
    padding: 28px 0;
    .tips-text {
      color: #747a87;
      font-size: 16px;
      line-height: 24px;
    }
  }

  /deep/.el-input-group__append {
    background: rgba(153, 196, 28, 0.2);
    .el-icon-search {
      color: #99c41c;
    }
  }

  .footer {
    margin-top: 15px;
    text-align: end;
    /deep/.el-input__inner {
      border-radius: 2px;
    }
  }
}
</style>
